export default __webpack_public_path__ + "static/media/indicator-quote1.bd68f124.svg";